function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var t = function t(_t) {
    return "object" == _typeof(_t) && null != _t && 1 === _t.nodeType;
  },
  e = function e(t, _e) {
    return (!_e || "hidden" !== t) && "visible" !== t && "clip" !== t;
  },
  n = function n(t, _n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      var _o = getComputedStyle(t, null);
      return e(_o.overflowY, _n) || e(_o.overflowX, _n) || function (t) {
        var e = function (t) {
          if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
          try {
            return t.ownerDocument.defaultView.frameElement;
          } catch (t) {
            return null;
          }
        }(t);
        return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
      }(t);
    }
    return !1;
  },
  o = function o(t, e, n, _o2, l, r, i, s) {
    return r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - _o2 : i > e && s < n || r < t && s > n ? i - e + l : 0;
  },
  l = function l(t) {
    var e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
  },
  r = function r(e, _r2) {
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    var c = _r2.scrollMode,
      f = _r2.block,
      u = _r2.inline,
      a = _r2.boundary,
      g = _r2.skipOverflowHiddenElements,
      p = "function" == typeof a ? a : function (t) {
        return t !== a;
      };
    if (!t(e)) throw new TypeError("Invalid target");
    var m = document.scrollingElement || document.documentElement,
      w = [];
    var W = e;
    for (; t(W) && p(W);) {
      if (W = l(W), W === m) {
        w.push(W);
        break;
      }
      null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
    }
    var b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth,
      H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight,
      _window = window,
      y = _window.scrollX,
      M = _window.scrollY,
      _e$getBoundingClientR = e.getBoundingClientRect(),
      v = _e$getBoundingClientR.height,
      E = _e$getBoundingClientR.width,
      x = _e$getBoundingClientR.top,
      C = _e$getBoundingClientR.right,
      I = _e$getBoundingClientR.bottom,
      R = _e$getBoundingClientR.left,
      _ref = function (t) {
        var e = window.getComputedStyle(t);
        return {
          top: parseFloat(e.scrollMarginTop) || 0,
          right: parseFloat(e.scrollMarginRight) || 0,
          bottom: parseFloat(e.scrollMarginBottom) || 0,
          left: parseFloat(e.scrollMarginLeft) || 0
        };
      }(e),
      T = _ref.top,
      B = _ref.right,
      F = _ref.bottom,
      V = _ref.left;
    var k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F,
      D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    var L = [];
    for (var _t2 = 0; _t2 < w.length; _t2++) {
      var _e2 = w[_t2],
        _e$getBoundingClientR2 = _e2.getBoundingClientRect(),
        _l = _e$getBoundingClientR2.height,
        _r = _e$getBoundingClientR2.width,
        _i = _e$getBoundingClientR2.top,
        _s = _e$getBoundingClientR2.right,
        _d = _e$getBoundingClientR2.bottom,
        _h = _e$getBoundingClientR2.left;
      if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (_e2 === m && !n(_e2) || x >= _i && I <= _d && R >= _h && C <= _s)) return L;
      var _a = getComputedStyle(_e2),
        _g = parseInt(_a.borderLeftWidth, 10),
        _p = parseInt(_a.borderTopWidth, 10),
        _W = parseInt(_a.borderRightWidth, 10),
        _T = parseInt(_a.borderBottomWidth, 10);
      var _B = 0,
        _F = 0;
      var _V = "offsetWidth" in _e2 ? _e2.offsetWidth - _e2.clientWidth - _g - _W : 0,
        S = "offsetHeight" in _e2 ? _e2.offsetHeight - _e2.clientHeight - _p - _T : 0,
        X = "offsetWidth" in _e2 ? 0 === _e2.offsetWidth ? 0 : _r / _e2.offsetWidth : 0,
        Y = "offsetHeight" in _e2 ? 0 === _e2.offsetHeight ? 0 : _l / _e2.offsetHeight : 0;
      if (m === _e2) _B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, _p, _T, M + k, M + k + v, v) : k - H / 2, _F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, _g, _W, y + D, y + D + E, E), _B = Math.max(0, _B + M), _F = Math.max(0, _F + y);else {
        _B = "start" === f ? k - _i - _p : "end" === f ? k - _d + _T + S : "nearest" === f ? o(_i, _d, _l, _p, _T + S, k, k + v, v) : k - (_i + _l / 2) + S / 2, _F = "start" === u ? D - _h - _g : "center" === u ? D - (_h + _r / 2) + _V / 2 : "end" === u ? D - _s + _W + _V : o(_h, _s, _r, _g, _W + _V, D, D + E, E);
        var _t3 = _e2.scrollLeft,
          _n2 = _e2.scrollTop;
        _B = 0 === Y ? 0 : Math.max(0, Math.min(_n2 + _B / Y, _e2.scrollHeight - _l / Y + S)), _F = 0 === X ? 0 : Math.max(0, Math.min(_t3 + _F / X, _e2.scrollWidth - _r / X + _V)), k += _n2 - _B, D += _t3 - _F;
      }
      L.push({
        el: _e2,
        top: _B,
        left: _F
      });
    }
    return L;
  };
export { r as compute };